var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-agent-list", {
    attrs: {
      avatar: _vm.avatar,
      agents: _vm.agents,
      actions: _vm.primary,
      "actions-type": _vm.actionsType,
      "rule-groups": _vm.ruleGroups,
      statuses: _vm.statuses,
      size: _vm.size,
      "default-search-options": _vm.defaultSearchOptions,
      "can-change-search-options": _vm.canChangeSearchOptions,
      "is-loading": _vm.isLoading,
      "is-disabled": _vm.isDisabled,
    },
    on: {
      "search-change": function ($event) {
        _vm.search = $event
      },
      "action-click": _vm.onActionClick,
    },
    scopedSlots: _vm._u([
      {
        key: "options-append",
        fn: function () {
          return [
            _vm.canInviteThirdParty && _vm.isSearchValidPhoneNumber
              ? _c("base-item", {
                  attrs: {
                    title: _vm.search,
                    description: _vm.normalizedPhoneNumber,
                    size: _vm.size,
                    actions: _vm.secondary,
                    "actions-type": _vm.actionsType,
                    "is-disabled": _vm.isDisabled,
                  },
                  on: {
                    "action-click": function ($event) {
                      return _vm.onActionClick({ key: $event })
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }